// extracted by mini-css-extract-plugin
export default {"code-block-shadow":"code-block-shadow--YwyUN"};